import { InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import { NumericFormat, NumericFormatProps } from "react-number-format";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  numeric?: boolean;
  decimalScale?: number;
  allowNegative?: boolean;
}

const Input = ({
  className,
  type,
  numeric,
  decimalScale = 2,
  allowNegative = true,
  ...props
}: InputProps) => {
  if (numeric) {
    const { value, ...numericProps } = props;
    return (
      <NumericFormat
        decimalScale={decimalScale}
        value={value?.toString() ?? ""}
        {...(numericProps as NumericFormatProps)}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-transparent placeholder:text-zinc-600 px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        allowNegative={allowNegative}
        allowedDecimalSeparators={[","]}
      />
    );
  }
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-transparent placeholder:text-zinc-600 px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props}
    />
  );
};

Input.displayName = "Input";

export { Input };
